const EnumArticleType = {
  PLAIN_TEXT: "PLAIN_TEXT",
  HTML: "HTML",
  URL: "URL",
  VIDEO: "VIDEO",
};

export default EnumArticleType;
